var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sacrifice-manage"},[_c('tableTemple',{attrs:{"list":_vm.memorialList},on:{"clickRemoveId":_vm.clickRemoveId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }